import * as z from "zod";
import { isoDate } from "./common";

/** One item sold. Cost and margin are null when the shop never recorded a cost. */
export const SalesReportRow = z.object({
  /** When it was paid. */
  date: isoDate,
  transactionId: z.string(),
  item: z.string(),
  detail: z.string().nullable(),
  quantity: z.number(),
  unitPriceCents: z.number(),
  saleCents: z.number(),
  unitCostCents: z.number().nullable(),
  costCents: z.number().nullable(),
  marginCents: z.number().nullable(),
  location: z.string().nullable(),
  /** "Card", "Tap to Pay", "Shopify", or the provider's key. */
  paidWith: z.string(),
});
export type SalesReportRow = z.output<typeof SalesReportRow>;

export const SalesReportTotals = z.object({
  itemsSold: z.number(),
  saleCents: z.number(),
  /** Over the rows that have a cost only. */
  costCents: z.number(),
  /** Over the rows that have a cost only. */
  marginCents: z.number(),
  rowsWithoutCost: z.number(),
  taxCents: z.number(),
  platformFeeCents: z.number(),
  processingFeeCents: z.number(),
  collectedCents: z.number(),
});
export type SalesReportTotals = z.output<typeof SalesReportTotals>;

/** A month of a shop's sales, cut in the shop's own time zone. */
export const SalesReport = z.object({
  /** YYYY-MM. */
  month: z.string(),
  timeZone: z.string(),
  currency: z.string(),
  rows: z.array(SalesReportRow),
  totals: SalesReportTotals,
});
export type SalesReport = z.output<typeof SalesReport>;
